module.exports = __webpack_public_path__ + "static/media/banner_DusKaDumVR-half.561160d6.png";